import type { CircularProgressProps } from "@mui/material";
import { CircularProgress } from "@mui/material";
import classNames from "classnames";
import styles from "./styles.module.css";

type Props = CircularProgressProps & {
  settingSize?: number;
  small?: boolean;
  big?: boolean;
  className?: string;
};

export const AppLoading: React.FC<Props> = ({
  className,
  small,
  big,
  settingSize,
}) => {
  return (
    <div className={classNames(styles.container, className)}>
      <CircularProgress
        className={classNames(styles.loading, className)}
        size={small ? 30 : big ? 50 : settingSize}
      />
    </div>
  );
};
